import PubSub from "underpub-js";

var ExpandableSections = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ExpandableSections',
	};

	$.extend(true, this.options, options);

};

ExpandableSections.prototype.init = function() {

	var self = this;

};

export default ExpandableSections;
